<template>

      <div class="flip-container" :class="{'flipped': isFlipped}">



        <div class="flipper">

          <div class="front w-100">
            <div class="col-sm-12 bg-lightest border-light cardHeight1 d-flex flex-column radius-normal" >
                <div v-if="loading" class="d-flex align-items-center justify-content-center w-100 h-100">
                    <loader></loader>
                </div>
                <div v-else>
                    <!-- <span class="cardFlipBtn" @click="toggleCard"><i class="ico-settings medium fs-larger pointer"></i></span> -->
                    <div class="mb-4">
                        <div class="text-center darker font-weight-600 mt-4 fs-large">
                            {{title}}
                        </div>
                        <div class="dark text-center fs-small">
                            {{subTitle}}
                        </div>
                    </div>
                    <div class="text-center w-100 mb-5 mt-4 infoHolder">
                        <graph class="graph w-100" :height="100" :chartData="graphData" ></graph>
                        <div class="fs-superBig dark mt-1">{{percent}}%</div>
                        <div class="fs-larger" :class="labelColor">{{label}}</div>
                    </div>
                </div>
            </div>
          </div>

          <div class="back w-100">
            <div class="col-sm-12 bg-lightest border-light cardHeight1 d-flex flex-column mt-3 radius-normal">
              <span class="cardFlipBtn" @click="toggleCard"><i class="ico-close medium fs-small pointer ml-auto"></i></span>

              <div class="darker font-weight-600 mt-4 mb-3">
                  Edit Widget
              </div>

              <div class="dark fs-small mt-2">
                Thresholder (%)
              </div>

              <div class="text-center mt-3">
                <input type="text" class="text-center" size="2" v-model="treshold.red.percent" />
                <i class="ico-minus darkest mx-1"></i>
                <input type="text" class="text-center" size="2" v-model="treshold.yellow.percent" />
              </div>

              <div class="row mt-3">

                <div class="col-sm-4 pr-0">
                  <div class="bg-color-6 tresholdBar">

                  </div>
                </div>

                <div class="col-sm-4 px-3">
                  <div class="bg-color-4 tresholdBar">

                  </div>
                </div>

                <div class="col-sm-4 pl-0">
                  <div class="bg-color-3 tresholdBar">

                  </div>
                </div>

              </div>

              <div class="mt-3">
                <button class="btn w-100" @click="toggleCard">Save</button>
              </div>

            </div>
          </div>

        </div>
      </div>


</template>

<script>
    import graph from '@/tools/charts/reports/occupancy'
    import Loader from '@/tools/loaders/loader1'

    export default {
        data: function(){
            return {
                treshold:{
                    yellow: {
                        percent: 50,
                        color: '#f8d46f'
                    },
                      red: {
                        percent: 20,
                        color: '#e73f47'
                    }
                },
                chartBackground: '#c5d0de',
                isFlipped: false
            }
        },
        computed:{
            graphData: function(){
                var percent = this.percent;
                var chartColor = this.chartColor;
                var chartBackground = this.chartBackground;

                var chartData = {
                    labels: ["Sold", "Free"],
                    datasets: [
                        {
                            label: 'Sold',
                            data: [percent,100 - percent],
                            backgroundColor: [
                                chartColor,
                                chartBackground
                            ],
                            hoverBackgroundColor: [
                                chartColor,
                                chartBackground
                            ]
                        }
                    ]
                };

                return chartData;
            },
            chartColor: function(){
                var treshold = this.treshold;
                var percent = this.percent;
                var outputColor = '#6ac951';

                for (var tresholdKey in treshold) {
                    if(percent <= treshold[tresholdKey].percent){
                        outputColor = treshold[tresholdKey].color;
                    }
                }

                return outputColor;
            }
        },
        methods:{
          toggleCard: function(){
            this.isFlipped ^= true;
          }
        },
        props:[
            'loading',
            'title',
            'subTitle',
            'percent',
            'label',
            'labelColor'
        ],
        components:{
            graph,
            Loader
        }
    }
</script>

<style scoped lang="scss">

  .cardHeight1{
      height: 230px;
  }

  .fs-superBig{
      font-size: 2.5rem;
  }

  .cardFlipBtn{
    position: absolute;
    right: 0.5rem;
    top: 1rem;
  }

  .infoHolder{
      position: relative;

      .graph{
          position: absolute;
          top: -1rem;
          left: 0;
      }

  }

  //settings
  .tresholdBar{height: 0.3rem;}
  // flip card
  .flip-container {
  	perspective: 1000px;
  }
  	/* flip the pane when hovered */
  	.flip-container.flipped .flipper, .flip-container.hover .flipper {
  		transform: rotateY(180deg);
  	}

  .flip-container, .front, .back {
  	// width: 320px;
  	// height: 480px;
  }

  /* flip speed goes here */
  .flipper {
  	transition: 0.6s;
  	transform-style: preserve-3d;

  	position: relative;
  }

  /* hide back of pane during swap */
  .front, .back {
  	backface-visibility: hidden;

  	position: absolute;
  	top: 0;
  	left: 0;
  }

  /* front pane, placed above back */
  .front {
  	z-index: 2;
  	/* for firefox 31 */
  	transform: rotateY(0deg);
  }

  /* back, initially hidden pane */
  .back {
  	transform: rotateY(180deg);
  }
</style>



// WEBPACK FOOTER //
// cardGraphOccupancy.vue?6800326e